// extracted by mini-css-extract-plugin
module.exports = {"root":"step-9_root__gu5x_","header":"step-9_header__3Mpcv","headerInner":"step-9_headerInner___UNjZ","checkmark":"step-9_checkmark__upg0O","content":"step-9_content__2JJvC"};